export const matching = "✅";
export const missing = "❌";
export const mock = "🥸";
export const mismatch = "️🩹";
